$j(document).foundation();